/* all the js that handles samples can be found in product-form.liquid */

/* TAB BEHAVIOUR
-----------------*/
// takes the ul.tabclass as tabs arg, and li element that should appear first.
function tabBehaviour(tabs, firstVisibleTab) {
  
  $(tabs).each(function() {
    
    let active, content, links = $(this).find('a');

    // jQuery not playing nice with detecting classes already in the DOM
    //   - resorting to pure JS to remove initial state
    firstVisibleTab.classList.add('active');

    active = links.find('active');
    content = $(active.attr('href'));

    $(this).find('a').click(function(e){

      // logic to ensure first VISIBLE tab is loaded first
      firstVisibleTab.classList.remove('active'); // for the first click event

      active.removeClass('active'); // jQuery handles subsequent clicks

      links.each(function () {
        $($(this).attr('href')).hide();
      });

      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;     

    });
                 
  });
  
}


$(document).ready(function() {
    
  /* Code to handle the product info tabs */
  let firstVisibleProductTab = document.getElementById('firstVisible-product-tab');
  let firstVisibleSampleTab = document.getElementById('tab-heading-full-sample');
    
  tabBehaviour($('ul.product-tabs'), firstVisibleProductTab);
  tabBehaviour($('ul.sample-tabs'), firstVisibleSampleTab ); 
  
  /* Gallery prev/next buttons disabled 
  /* Product Gallery Prev/Next buttons 
  $('.gallery-prev-next-buttons').on('click', (event) => {
    event.preventDefault();
        
    const $target = $(event.currentTarget);
    const $thumbNailCount = $('button.product-gallery--thumbnail-trigger').length; 
    
    let $activeThumbnail = $('.thumbnail--selected').data('product-thumbnail');
    
    $('.thumbnail--selected').removeClass('thumbnail--selected');
    $('figure[data-product-image-index=' + '"' + $activeThumbnail + '"]').removeClass('is-selected image--selected');
    
    if ($target.hasClass('prev')) { 
      if ($activeThumbnail > 0 ) {
      	$activeThumbnail-- 
      } else {
        $activeThumbnail = $thumbNailCount - 1;
      }        
    } else { 
      if ($activeThumbnail < $thumbNailCount - 1 ) {
      	$activeThumbnail++ 
      } else {
        $activeThumbnail = 0;
      }
    }
    
    $('button[data-product-thumbnail=' + '"' + $activeThumbnail + '"]').addClass('thumbnail--selected');
    $('figure[data-product-image-index=' + '"' + $activeThumbnail + '"]').addClass('is-selected image--selected');
    
  }); 
  
  */

});

/* SMOOTH SCROLL TRANSITION
---------------------------*/
// cache the html
let $root = $('html, body');
$(document).on('click', 'a[href^="#product-info-header"]', function (event) {
    event.preventDefault();

  if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {           
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 160
    }, 750);
    
  } else {

    $root.animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 60
    }, 750);
  }
});

$(document).on('click', 'a[href^="#top"]', function (event) {
    event.preventDefault();

    $root.animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 750);
});




